const a = require("handlebars.numeral");

export const numeralHelper:any = a;
